'use strict';
Object.defineProperty(exports, Symbol.toStringTag, {
    value: 'Module'
});
var words = require('./words.js');
function startCase(str) {
    var words$1 = words.words(str.trim());
    var result = '';
    for(var i = 0; i < words$1.length; i++){
        var word = words$1[i];
        if (result) {
            result += ' ';
        }
        result += word[0].toUpperCase() + word.slice(1).toLowerCase();
    }
    return result;
}
exports.startCase = startCase;
